// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 719) return "public/css/build/release-cloudweb-15526-138-0-0.202308011221/main.css";
	// return url for filenames based on template
	return undefined;
};